import { JsonItem } from "../../entities/pick-list/pick-list.entities";
import { FormSection } from "./web-form.objects";
import _ from "lodash";

export class WebForm {
    formSections: FormSection[];
    currentItem: any;
    defaultItem: any;

    saveRoute: string;
    isSaving: boolean = false;

    constructor(config: WebFormConfig) {
        this.formSections = config.formSections;
        this.saveRoute = config.saveRoute;
        this.defaultItem = config.defaultItem;
    }

    initialize(pickLists: JsonItem[]) {
        this.formSections.forEach(section => section.initialize(pickLists));
    }

    async saveForm(): Promise<any> {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        let formObj = _.cloneDeep(this.currentItem);

        // Update Form
        this.formSections.forEach(section => {
            section.formFields.forEach(field => {
                formObj = field.updateItem(formObj);
            })
        })

        let result: any;
        try {
            result = await $.ajax(this.saveRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(formObj),
                contentType: "application/json"
            });
            this.isSaving = false;
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}

export class WebFormConfig {
    formSections: FormSection[];
    saveRoute: string; // route to post to save item;
    defaultItem: any; // base item to use if new
}